import { useEffect } from 'react';
import { useCreateModalStore } from '../../../../stores/createModalStore';
import { CreateModal } from './CreateModal';

/**
 * Layout's mount point. Drops any open request when the modal unmounts (a
 * Layout remount, a shell switch), so it can never reopen by itself later.
 */
export function CreateModalHost() {
  useEffect(() => () => useCreateModalStore.getState().close(), []);
  return <CreateModal />;
}
